import { render, staticRenderFns } from "./TransferLead.vue?vue&type=template&id=1ec9b787"
import script from "./TransferLead.vue?vue&type=script&lang=js"
export * from "./TransferLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports